exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".single-select {\n  width: 90%;\n}\n.single-select .multiselect__select::before {\n  display: none;\n}", ""]);

// exports
